/**
 * @generated SignedSource<<20eb52e8e3304af70962e9b3cb2dedb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useAdminMutationsRemoveOrgRoleMutation$variables = {
  id: string;
};
export type useAdminMutationsRemoveOrgRoleMutation$data = {
  readonly removeAdminOrganizationRole: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly id: string;
      readonly role: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly roleId: string;
    } | null | undefined;
  };
};
export type useAdminMutationsRemoveOrgRoleMutation = {
  response: useAdminMutationsRemoveOrgRoleMutation$data;
  variables: useAdminMutationsRemoveOrgRoleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RemoveAdminOrganizationRoleResult",
    "kind": "LinkedField",
    "name": "removeAdminOrganizationRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminOrganizationRole",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsRemoveOrgRoleMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsRemoveOrgRoleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c56ef8fcb7abbeb191dfa8346cdf2041",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsRemoveOrgRoleMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsRemoveOrgRoleMutation(\n  $id: ID!\n) {\n  removeAdminOrganizationRole(id: $id) {\n    result {\n      id\n      roleId\n      role {\n        id\n        name\n      }\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "797ad355395849a251b09294abbc49c0";

export default node;
